import React, {FC, JSX, memo, ReactNode, useCallback, useEffect, useLayoutEffect, useRef, useState} from "react";
import {Dropdown, DropdownItem, DropdownMenu, FormControl} from "react-bootstrap";
import {
    SelectComponentContainer,
    SelectComponentControl,
    SelectComponentDrop,
    SelectComponentDropName, SelectComponentDropPath
} from "./SelectComponentStyle";


export type ISelect = {
    id: number | null;
    value: string;
    description: string;
}

type SelectNewProps = {
    options: ISelect[]
    onSelect: (item: ISelect) => void
    placeholder?: string
    value?: string
}

const SelectNew: FC<SelectNewProps> = (props) => {
    const [showMenu, setShowMenu] = useState(false)
    const [value, setValue] = useState<string>('')
    const [valueSave, setValueSave] = useState<string>('')
    const ref = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        if (props.value && props.options.map(option => option.value).includes(props.value)) {
            setValue(props.value)
        }

    }, [props.value])

    useEffect(() => {
            const check = (e: any) => {
                if (showMenu && ref.current && !ref.current.contains(e.target)) {
                    setShowMenu(false)
                    if (value.length === 0) {
                        setValue(valueSave);
                    } else {
                        setValueSave(value)
                    }
                }
            }

            document.addEventListener("mousedown", check)
            document.addEventListener("touchend", check)
            return () => {
                document.removeEventListener("mousedown", check)
                document.removeEventListener("touchend", check)
            }
        }
        , [showMenu, value])

    const onMenu = useCallback((event: React.MouseEvent<HTMLInputElement>) => {
        setShowMenu(true)
        setValue('')
    }, [showMenu])


    const onClickItem = useCallback((event: React.MouseEvent<HTMLElement>, item: ISelect) => {
        setValue(item.value)
        setValueSave(item.value)
        setShowMenu(false)
        props.onSelect(item)

    }, [showMenu])


    const isEmpty = useCallback((): boolean => {
        return props.options.filter(opt => opt.value.includes(value) || opt.description.includes(value)).length === 0
    }, [value])

    const items = (): React.JSX.Element[] => {
        return  props.options.filter(opt => opt.value.includes(value) || opt.description.includes(value)).map(item => {
           return( <DropdownItem onClick={(e) => onClickItem(e, item)}>
               <SelectComponentDrop>
                   <SelectComponentDropName>{item.value}</SelectComponentDropName>
                   <SelectComponentDropPath>{item.description}</SelectComponentDropPath>
               </SelectComponentDrop>
            </DropdownItem>)
        })
    }


    return (
        <SelectComponentContainer style={{margin: 0}}>
            <FormControl type={"text"} value={value} onChange={v => {
                setValue(v.target.value)
                props.onSelect({value: v.target.value, description: v.target.value} as ISelect)

            }}
                                    onClick={onMenu} placeholder={props.placeholder}/>
            <Dropdown hidden={isEmpty()} style={{width: "100%", height: 0}} show={showMenu} ref={ref}>
                <DropdownMenu style={{width: "100%", maxHeight: "150px", overflow: "scroll"}}>
                    { items()}
                </DropdownMenu>
            </Dropdown>
        </SelectComponentContainer>
    )
}
export default memo(SelectNew)
